import { routes } from 'core/routes';
import { Router } from '@resn/gozer-core/router';
import Copy from '@resn/gozer-core/copy';
import store from 'core/store';
import { PAGE_DATA } from 'data/page-data';
import { disablePinchToZoom } from 'utils/mobile-utils';
import setViewportMetaTag from 'utils/set-viewport-meta-tag';
import { isMobile, isIOS } from '@resn/gozer-env';
import 'intersection-observer';
import ResizeObserver from 'resize-observer-polyfill';

// Intl.NumberFormat polyfill
import '@formatjs/intl-locale/polyfill';
import '@formatjs/intl-numberformat/polyfill';
import '@formatjs/intl-numberformat/locale-data/en'; // locale-data for en

export const setupRouter = async () => {
    // start routing
    Router.on(Router.NAVIGATE, (route) => {
        // update store with current route data
        store().state.route.page = route.match.page;
        store().state.route.pathname = route.pathname;
        store().state.route.params = route.params;
    });
    Router.init(routes);
};

export const setupMetadata = async () => {
    Router.on(Router.NAVIGATE, (route) => {
        const pageId = store().state.route.page;
        const page = PAGE_DATA[pageId.toUpperCase()] || {};

        const meta = {
            title: Copy.hasCopyFor(page.title) || Copy.get('home-meta-default-title'),
            description: Copy.hasCopyFor(page.description) || Copy.get('home-meta-default-description'),
        };

        Router.updateMeta(meta);
    });
};

export const setupDevice = async () => {
    if (isMobile && !isIOS) setViewportMetaTag();
    // prevent pinch to zoom interactions on touch devices
    // disablePinchToZoom();
};

export const setupPolyfills = async () => {
    window.ResizeObserver = ResizeObserver;
};
